class MobileCartBar extends HTMLElement {
  connectedCallback() {
    this.summaryEl = this.querySelector('[data-mobile-cart-summary]');
    this.openBtn = this.querySelector('[data-mobile-cart-open]');
    this._onCartUpdate = this.onCartUpdate.bind(this);
    this._onOpenClick = this.openCart.bind(this);
    this._onResize = this.syncVisibility.bind(this);
    this._onDrawerChange = this.onDrawerChange.bind(this);

    if (this.openBtn) {
      this.openBtn.addEventListener('click', this._onOpenClick);
    }

    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this._onCartUpdate
    );

    window.addEventListener('resize', this._onResize);
    document.addEventListener('drawer:handleAfterShow', this._onDrawerChange);
    document.addEventListener('drawer:handleAfterHide', this._onDrawerChange);

    this.updateFromCart({
      item_count: Number(this.dataset.itemCount || 0),
      total_price: Number(this.dataset.totalPrice || 0),
    });
    this.syncSheetClass();
  }

  disconnectedCallback() {
    if (this.openBtn) this.openBtn.removeEventListener('click', this._onOpenClick);
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    window.removeEventListener('resize', this._onResize);
    document.removeEventListener('drawer:handleAfterShow', this._onDrawerChange);
    document.removeEventListener('drawer:handleAfterHide', this._onDrawerChange);
  }

  get isMobile() {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  get cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  onCartUpdate(event) {
    const cart = event?.cart;
    if (!cart) return;
    this.updateFromCart(cart);
  }

  onDrawerChange() {
    this.syncVisibility();
    this.syncSheetClass();
  }

  syncSheetClass() {
    const sheetOpen = Boolean(
      document.querySelector('drawer-component.product-card-sheet[open], .product-card-sheet[open]')
    );
    document.body.classList.toggle('product-sheet-open', sheetOpen);
  }

  updateFromCart(cart) {
    const count = Number(cart.item_count || 0);
    const total = Number(cart.total_price || 0);

    this.dataset.itemCount = String(count);
    this.dataset.totalPrice = String(total);

    if (this.summaryEl) {
      const money =
        FoxTheme?.Currency?.formatMoney && FoxTheme?.settings?.moneyFormat
          ? FoxTheme.Currency.formatMoney(total, FoxTheme.settings.moneyFormat)
          : (total / 100).toFixed(2) + ' €';

      const countStrings = FoxTheme?.attarStrings?.cartCount || {};
      const label =
        count === 1
          ? (countStrings.one || '[count] item').replace(/\[count\]/g, '1')
          : (countStrings.other || '[count] items').replace(/\[count\]/g, String(count));
      this.summaryEl.textContent = count > 0 ? `${label} · ${money}` : '';
    }

    document.body.classList.toggle('attar-cart-has-items', count > 0);
    this.syncVisibility();
  }

  syncVisibility() {
    const count = Number(this.dataset.itemCount || 0);
    const drawerOpen = Boolean(this.cartDrawer && this.cartDrawer.open);
    const shouldShow =
      this.isMobile && count > 0 && !drawerOpen && !document.body.classList.contains('cart-template');

    if (shouldShow) {
      this.hidden = false;
      this.removeAttribute('aria-hidden');
      this.classList.add('is-visible');
      document.body.classList.add('mobile-cart-bar-open');
    } else {
      this.classList.remove('is-visible');
      this.hidden = true;
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-cart-bar-open');
    }
  }

  openCart() {
    const drawer = this.cartDrawer;
    if (drawer && typeof drawer.show === 'function') {
      drawer.show(this.openBtn);
      return;
    }
    window.location.href = FoxTheme?.routes?.cart_url || '/cart';
  }
}

customElements.define('mobile-cart-bar', MobileCartBar);

/** Ensure a bar exists once the cart gets its first item (empty pages omit the markup). */
(function ensureMobileCartBar() {
  function createBar(cart) {
    if (document.getElementById('MobileCartBar')) return document.getElementById('MobileCartBar');
    if (document.body.classList.contains('cart-template')) return null;

    const el = document.createElement('mobile-cart-bar');
    el.id = 'MobileCartBar';
    el.className = 'mobile-cart-bar';
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    el.dataset.itemCount = String(cart?.item_count || 0);
    el.dataset.totalPrice = String(cart?.total_price || 0);
    el.innerHTML =
      '<div class="mobile-cart-bar__inner">' +
      '<p class="mobile-cart-bar__summary" data-mobile-cart-summary></p>' +
      '<button type="button" class="mobile-cart-bar__cta" data-mobile-cart-open>' +
      (window.FoxTheme?.attarStrings?.viewCart || 'Voir le panier') +
      '</button>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  function onCartUpdate(event) {
    const cart = event?.cart;
    if (!cart) return;

    document.body.classList.toggle('attar-cart-has-items', Number(cart.item_count || 0) > 0);

    if (!cart.item_count) return;
    const bar = createBar(cart);
    if (bar && typeof bar.updateFromCart === 'function') {
      bar.updateFromCart(cart);
    }
  }

  function init() {
    if (!window.FoxTheme?.pubsub) return;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);

    // Seed from server-rendered html class / existing cart count on page load
    if (document.documentElement.classList.contains('cart-has-items')) {
      document.body.classList.add('attar-cart-has-items');
    }

    markExistingGiftFabs();
  }

  /** Tag Klaviyo gift teaser (and similar) for hide-via-CSS. */
  function markExistingGiftFabs() {
    document
      .querySelectorAll('.kl-teaser-SVYHgm, [class*="kl-teaser-"]')
      .forEach((el) => el.classList.add('as-float--gift'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', () => {
    setTimeout(markExistingGiftFabs, 800);
    setTimeout(markExistingGiftFabs, 2500);
  });
})();
